import {FormInput} from "@/components/forms/FormInput.jsx";
import { Box, Stack, Button, Card } from '@mui/joy';
import { useFieldArray } from 'react-hook-form';
import Add from '@mui/icons-material/Add';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';
import { MIN_EQUIPMENTS, MAX_EQUIPMENTS, newEquipment } from '@/features/recipes/schema';

export function EquipmentFormTab() {
  const { fields, append, remove } = useFieldArray({ name: 'equipment' });  

  return (
    <Card variant="outlined">
      <Stack spacing={2}>
        {fields.map((field, index) =>        
          <Stack key={field.id} direction="row" alignItems="start" gap={1}>        
            <EquipmentForm key={field.id} path={`equipment.${index}`} sx={{ flexGrow: 1 }} />
            {fields.length > MIN_EQUIPMENTS && <RemoveFormElementButton onClick={() => remove(index)} />}
          </Stack>
        )}
        {fields.length < MAX_EQUIPMENTS && <Box>
          <Button startDecorator={<Add />} variant="outlined" onClick={() => append(newEquipment())}>Add Equipment</Button>
        </Box>} 
      </Stack>
    </Card>
  )
}

function EquipmentForm({ path, sx }) {  
  return (
    <FormInput name={`${path}.name`} placeholder="Equipment name" sx={sx} />
  )
}


